var _defineProperty = require("/codebuild/output/src1368910246/src/jag-website/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var plugin = require('tailwindcss/plugin');
var baseStyles = {
  overflow: 'hidden',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical'
};
var lineClamp = plugin(function (_ref) {
  var matchUtilities = _ref.matchUtilities,
    addUtilities = _ref.addUtilities,
    theme = _ref.theme,
    variants = _ref.variants;
  var values = theme('lineClamp');
  matchUtilities({
    'line-clamp': function lineClamp(value) {
      return _objectSpread(_objectSpread({}, baseStyles), {}, {
        '-webkit-line-clamp': "".concat(value)
      });
    }
  }, {
    values: values
  });
  addUtilities([{
    '.line-clamp-none': {
      '-webkit-line-clamp': 'unset'
    }
  }], variants('lineClamp'));
}, {
  theme: {
    lineClamp: {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
      6: '6'
    }
  },
  variants: {
    lineClamp: ['responsive']
  }
});
module.exports = lineClamp;